//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('sops', {
//        templateUrl: 'views/components/views/sops/sops.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'sopsService', function (stateService, sopsService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
            
//            vm.model = {
//                itemsListSops: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE CALLS

//            let loadSops = function () {
//                sopsService.listSops().then(function (list) {
//                    angular.copy(list, vm.model.itemsListSops);
//                });
//            };

//            // #endregion LOAD PROCEDURE CALLS

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                let go = function (parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                };

//                switch (state) {
//                    case 'sop':
//                        go({ sop_keyno: '0' });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadSops();
//            };

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
